<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>confirmation_number</md-icon>
					</template>

					<template slot="content">
						<p class="category">Total e-ticket</p>
						<h3 class="title">{{stat.total_pass}}</h3>
					</template>
				</stats-card>
			</div>
			
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>check_circle</md-icon>
					</template>
					<template slot="content">
						<p class="category">Total check-ins</p>
						<h3 class="title">{{stat.total_checkin}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>supervised_user_circle</md-icon>
					</template>
					<template slot="content">
						<p class="category">Total administrators</p>
						<h3 class="title">{{stat.total_admin}}</h3>
					</template>
				</stats-card>
			</div>
			<!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<md-card>
					<md-card-header data-background-color="orange">
						<h4 class="title">សមាជិកថ្មី</h4>
						<p class="category">សមាជិកទើបបញ្ចូលថ្មី ៥ ចុងក្រោយ</p>
					</md-card-header>
					<md-card-content>
						<new-member></new-member>
					</md-card-content>
				</md-card>
			</div> -->
		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import {
		NewMember
	} from '@/pages/Dashboard/index'

	export default {
		components: {
			StatsCard,
			NewMember
		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
		},
		computed: {
		},
		data() {
			return {
				loaded: true,
				stat: {
					total_admin: 0,
					total_pass: 0,
					total_approve_pass: 0,
					total_reject_pass: 0,
					total_checkin: 0,
					total_current_checkin: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue